module.exports = __webpack_public_path__ + "assets/img/shouxin.1b8918ae.png";